'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bootstrap = bootstrap;

var _notification = require('antd/lib/notification');

var _notification2 = _interopRequireDefault(_notification);

var _message2 = require('antd/lib/message');

var _message3 = _interopRequireDefault(_message2);

var _fallbackRoutes = require('./fallbackRoutes');

var _beatle = require('beatle');

var _layers = require('../layers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bootstrap(app, getInitData, versionKey, inters) {
  _message3.default.config({
    top: 51
  });

  _beatle.crud.console = {
    success: _message3.default.success,
    error: function error(msg, err) {
      if (err) {
        if (!err.catched) {
          _notification2.default.error({ message: msg, description: err.message });
        }
      } else {
        _notification2.default.error({ message: 'ApiException', description: msg });
      }
    }
  };

  function proccessData(res) {
    if (res) {
      var _message = res.error || res.errorMessage || res.errMsg || res.message;
      if (_message) {
        return new Error(_message && JSON.stringify(_message, null, 2));
      } else {
        return res.data || null;
      }
    } else {
      return null;
    }
  }

  app.ajax.set('beforeRequest', function (ajaxOption) {
    if (ajaxOption.getMock || ajaxOption.mock) {
      return Promise.resolve(ajaxOption.getMock ? ajaxOption.getMock(ajaxOption) : ajaxOption.mock);
    } else {
      return ajaxOption;
    }
  });
  app.ajax.set('afterResponse', function (res, option, xhr) {
    xhr.catch(function (err) {
      err.catched = true;
      _notification2.default.error({ message: 'ApiException', description: err.message });
    });

    if (inters) {
      for (var key in inters) {
        res = inters[key](res, app);
        if (res instanceof Error) {
          return res;
        }
      }
    } else {
      res = proccessData(res, app);
    }
    return res;
  });

  // fallback路由
  app.route(_fallbackRoutes.fallbackRoutes, false);
  var promise = getInitData && getInitData() || Promise.resolve({});
  promise = promise.then(function () {
    var ret = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var route = app.route('/');
    var childRoutes = void 0;
    if (ret.scenes) {
      childRoutes = _layers.Layer.createLayerRoutes(ret.scenes);
      route.childRoutes = childRoutes;
      app.setRoutes(childRoutes, null, route);
    }
    return {
      versionKey: versionKey,
      prefix: bootstrap.getPrefix(app),
      dom: document.getElementById('main')
    };
  });

  return function ready(callback) {
    promise.then(callback);
  };
}

bootstrap.getPrefix = function (app, name) {
  var o = window.CONFIG || {};
  var prefix = o.prefix || '';
  return prefix + (name ? '/' + name : '') || (o.root || 'oa') + '/' + (name || app.appName);
};

bootstrap.getResolvePath = function (app, name) {
  var resolvePath = bootstrap.getPrefix(app, name);
  return resolvePath[0] === '/' ? resolvePath : '/' + resolvePath;
};


//////////////////
// WEBPACK FOOTER
// ./src/core/bootstrap.js
// module id = 43
// module chunks = 0